import { useEffect, useRef } from 'react';

const MODAL_SELECTOR = '.MuiModal-root, .MuiDialog-root, .MuiDrawer-root';

const isActiveModalRoot = (element) =>
  element.getAttribute('aria-hidden') !== 'true' &&
  element.style.display !== 'none' &&
  element.style.visibility !== 'hidden';

const hasOpenModal = () =>
  Array.from(document.body.querySelectorAll(MODAL_SELECTOR)).some(isActiveModalRoot);

const ModalScrollLock = () => {
  const lockRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined;
    }

    const html = document.documentElement;
    const body = document.body;

    const lock = () => {
      if (lockRef.current) return;

      const scrollY = window.scrollY || window.pageYOffset || 0;
      lockRef.current = {
        bodyLeft: body.style.left,
        bodyOverflow: body.style.overflow,
        bodyPosition: body.style.position,
        bodyRight: body.style.right,
        bodyTop: body.style.top,
        bodyWidth: body.style.width,
        htmlOverflow: html.style.overflow,
        scrollY,
      };

      html.classList.add('tavern-modal-open');
      body.classList.add('tavern-modal-open');
      html.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    };

    const unlock = () => {
      const lockState = lockRef.current;
      if (!lockState) return;

      html.classList.remove('tavern-modal-open');
      body.classList.remove('tavern-modal-open');
      html.style.overflow = lockState.htmlOverflow;
      body.style.position = lockState.bodyPosition;
      body.style.top = lockState.bodyTop;
      body.style.left = lockState.bodyLeft;
      body.style.right = lockState.bodyRight;
      body.style.width = lockState.bodyWidth;
      body.style.overflow = lockState.bodyOverflow;
      lockRef.current = null;
      window.scrollTo(0, lockState.scrollY);
    };

    const updateLock = () => {
      if (hasOpenModal()) {
        lock();
      } else {
        unlock();
      }
    };

    updateLock();
    const observer = new MutationObserver(updateLock);
    observer.observe(body, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      unlock();
    };
  }, []);

  return null;
};

export default ModalScrollLock;
